/**
 * Create a begin measure function, returning an `end` measure function.
 * @param {number} [start]
 * @returns {function<number>}
 */
export const begin = (start = performance.now()) => () => performance.now() - start;
